import { Pipe, PipeTransform } from "@angular/core";
import { DateTime } from "luxon";


@Pipe({name: 'updatedTimestamp', standalone: false})
export class UpdatedTimestampPipe implements PipeTransform {
  transform(isoString: string): string {
    const dt = DateTime.fromISO(isoString);
    return `${dt.toFormat('t ZZZZ')}, ${dt.toFormat('MM/dd/yyyy')}`;
  }
}